import React, {Component} from 'react';
import * as content from '../constants/exportcontent'
import {deepCopyObject, showAxiosError} from "../helper/helper";
import Datetime from "react-datetime";
import Select from"../local_node_modules/react-select"
import moment from "moment";
import {request} from "../helper/APIUtils";
import {eBelgeIn} from "../constants/exportcontent";

class ExcelCustomizer extends Component {

	constructor(props) {
		super(props);

		this.state = {content: [],
			customData: [],
			cities:[],
			selectedCity: "",
			selectedTaxOffice: "",
			selectedSubdivision: "",
			subdivisions:[],
			taxOffices:[],
			filteredTaxOffices:[],
			filteredSubdivisions: []}
		this.onCityChange=this.onCityChange.bind(this)
		this.onTaxOfficeChange=this.onTaxOfficeChange.bind(this)
		this.onSubdivisionChange=this.onSubdivisionChange.bind(this)

	}

	componentDidMount() {

		this.getCities();
		this.getTaxOffices();
		this.getSubdivisions();


		let modifiedContent = [];
		if (this.props.type === 'outbox') {
			modifiedContent = content.outboxContent;
		}
		if (this.props.type === 'inbox') {
			modifiedContent = content.inboxContent;
		}
		if (this.props.type === 'despatch_outbox') {
			modifiedContent = content.despatchOutboxTransferContent;
		}
		if (this.props.type === 'despatch_inbox') {
			modifiedContent = content.despatchInboxTransferContent;
		}
		if (this.props.type === 'eDespatchOutbox') {
			modifiedContent = content.eDespatchOutboxContent;
		}
		if (this.props.type === 'eDespatchInbox') {
			modifiedContent = content.eDespatchInboxContent;
		}
		if (this.props.type === 'eArchive') {
			modifiedContent = content.eArchiveContent;
		}
		if (this.props.type === 'inboxTransfer') {
			modifiedContent = content.inboxTransferContent;
		}
		if (this.props.type === 'outboxTransfer') {
			modifiedContent = content.outboxTransferContent;
		}
		if (this.props.type === 'eArchiveTransfer') {
			modifiedContent = content.eArchiveTransferContent;
		}
		if (this.props.type === 'archiveVoucher') {
			modifiedContent = content.archiveVoucherContent;
		}
		if (this.props.type === 'customer') {
			modifiedContent = content.customerContent;
		}
		if (this.props.type === 'eVoucherTransfer') {
			modifiedContent = content.eVoucherTransferContent;
		}
		if (this.props.type === 'progressPayment') {
			modifiedContent = content.progressPaymentContent;
		}
		if (this.props.type === 'progressPaymentPaytr') {
			modifiedContent = content.progressPaymentPaytrContent;
		}
		if (this.props.type === 'progressPaymentHakedis') {
			modifiedContent = content.progressPaymentHakedisContent;
		}
		if(this.props.type === 'progressPaymentDistributor'){
			modifiedContent = content.distributorContent;
		}
		if(this.props.type === 'expenseNote'){
			modifiedContent = content.expenseNoteContent;
		}
		if(this.props.type === 'eExchangeList'){
			modifiedContent = content.exchangeStatusContent;
		}
		if(this.props.type === 'belgeIn'){
			modifiedContent = content.eBelgeIn;
		}



		modifiedContent.map(mc => mc.selected = true);
		this.setState({
			content: modifiedContent,
			customData: modifiedContent
		});
	}



	handleSelect(data) {
		let content = deepCopyObject(this.state.content);
		let customData = deepCopyObject(this.state.customData);
		let column = {};

		content.find(function (obj) {
			return obj.name === data.name
		}).selected = !content.find(function (obj) {
			return obj.name === data.name
		}).selected;

		column.name = data.name;
		column.accessor = data.accessor;
		column.type = data.type;
		column.subAccessor = data.subAccessor;
		let obj = customData.find(function (obj) {
			return obj.name === data.name;
		});
		if (!obj) {
			customData.push(column);
			this.setState({customData, content});
		} else {
			let index = customData.indexOf(obj);
			customData.splice(index, 1);
			console.log(data);
			this.setState({customData, content})
		}
	}

	selectAll() {
		this.props.handleSelectAllDocuments();
	}

	onChangeDate(e, field) {
		this.props.onChangeDate(e, field)
	}

	defineTarget(type) {
		let target = {};
		switch (type) {
			case 'inbox':
			case 'inboxTransfer':
			case 'eDespatchInbox':
				target.targetName = 'Gönderici';
				target.targetId = 'sourceId';
				target.targetTitle = 'sourceTitle';
				break;
			case 'outbox':
			case 'outboxTransfer':
			case 'eArchive':
			case 'eArchiveTransfer':
			case 'eVoucherTransfer':
			case 'archiveVoucher':
			case 'eDespatchOutbox':
			case 'eExchangeList':
			case 'expenseNote':
				target.targetName = 'Alıcı';
				target.targetId = 'destinationId';
				target.targetTitle = 'destinationTitle';
				break;
			case 'customer' :
				target.targetName = '';
				target.targetId = 'vknTckn';
				target.targetTitle = 'formattedName';
				break;
			case 'progressPayment':
				target.targetName = '';
				target.targetId = 'vknTckn';
				target.targetTitle = 'customerName';
				break;
			case 'progressPaymentPaytr':
				target.targetName = '';
				target.targetId = 'vknTckn';
				target.targetTitle = 'customerName';
				break;
			case 'belgeIn':
				target.targetName = '';
				target.targetId = 'vknTckn';
				target.targetTitle = 'title';
				break;
		}
		return target;
	}
	onCityChange(e) {

		if(e === null){
			this.setState({selectedCity: ""});
			this.state.filteredTaxOffices = this.state.taxOffices.filter(to => to.city === "");
			this.state.filteredSubdivisions = this.state.subdivisions.filter(sd => sd.cityName === "");
		}else {
			this.setState({selectedCity: e.value});
			this.state.filteredTaxOffices = this.state.taxOffices.filter(to => to.city === e.value)
			this.state.filteredSubdivisions = this.state.subdivisions.filter(sd => sd.cityName === e.value)
			this.props.filterResults(e, 'city');
		}
	}

	onTaxOfficeChange(e){
		if(e === null){
			this.setState({selectedTaxOffice: ""});
		}else {
			this.setState({selectedTaxOffice:e.value});
			this.props.filterResults(e, 'taxOffice');
		}
	}

	onSubdivisionChange(e){
		if(e === null){
			this.setState({selectedSubdivision: ""});
		}else {
			this.setState({selectedSubdivision:e.value});
			this.props.filterResults(e, 'subdivision');
		}
	}


	defineValue(type) {
		let value;
		switch (type) {
			case 'inbox':
			case 'inboxTransfer':
			case 'eDespatchInbox':
				value = this.props.sourceId;
				break;
			case 'outbox':
			case 'outboxTransfer':
			case 'eArchive':
			case 'eArchiveTransfer':
			case 'eVoucherTransfer':
			case 'archiveVoucher':
			case 'eDespatchOutbox':
			case 'eExchangeList':
			case 'expenseNote':
				value = this.props.destinationId;
				break;
			case 'customer':
				value = this.props.vknTckn;
				break;
			case 'progressPayment':
				value = this.props.vknTckn;
				break;
			case 'progressPaymentPaytr':
				value = this.props.vknTckn;
				break;
		}
		return value;
	}


	async getCities(){
		let self = this;
		let params = {
			url: '/customer/getCities',
			method: "post",
		};
		let result = null;
		await request(params)
			.then(function (response) {
				result = response.data
			}).catch(function (error) {
				showAxiosError(error);
			});

		self.setState({cities:result});
	}

	async getSubdivisions(){
		let self = this;
		let params = {
			url: '/customer/getSubdivisions',
			method: "post",
		};
		let result = null;
		await request(params)
			.then(function (response) {
				result = response.data
			}).catch(function (error) {
				showAxiosError(error);
			});

		self.setState({subdivisions:result});
	}
	async getTaxOffices(){
		let self = this;
		let params = {
			url: '/customer/getTaxOffices',
			method: "post",
		};
		let result = null;
		await request(params)
			.then(function (response) {
				result = response.data
			}).catch(function (error) {
				showAxiosError(error);
			});

		self.setState({taxOffices:result});
	}




	render() {
		const archiveStates = [
			{value: '0', label: 'Arşivlenmeyenler'},
			{value: '1', label: 'Arşivlenenler'},
			{value: '', label: 'Tümü'}
		];

		const responseCodes = [
			{value: 'RED', label: 'Red'},
			{value: 'KABUL', label: 'Kabul'},
			{value: '', label: 'Tümü'}
		];

		const documentProfiles = [
			{value: 'TEMELFATURA', label: 'Temel Fatura'},
			{value: 'TICARIFATURA', label: 'Ticari Fatura'},
			this.props.type === 'outbox' ? {value: 'IHRACAT', label: 'İhracat Fatura'} : [],
			this.props.type === 'outbox' ? {value: 'YOLCUBERABER', label: 'Yolcu Beraber'} : [],
			{value: '', label: 'Tümü'}
		];

		const invoiceTypeCodes = [
			{value: 'SATIS', label: 'Satış'},
			{value: 'IADE', label: 'İade'},
			{value: 'ISTISNA', label: 'İstisna'},
			{value: 'TEVKIFAT', label: 'Tevkifat'},
			this.props.type === 'outbox' ? {value: 'SGK', label: 'SGK'} : [],
			{value: 'OZELMATRAH', label: 'Özel Matrah'},
			{value: 'IHRACKAYITLI', label: 'İhraç Kayıtlı'},
			{value: '', label: 'Tümü'}
		];

		const cancelled = [
			{value: 0, label: 'İptal Edilmemiş'},
			{value: 1, label: 'İptal Edilmiş'},
			{value: '', label: 'Tümü'}
		];

		const documentType = this.props.type;

		return (
			<div>
				<div className='col-sm-12 row'>
					{documentType !== 'customer' &&
					<div className='col-sm-6' style={{padding: '0', borderRightStyle: 'inset', borderRightWidth: 'thin'}}>
						<div className="card-header">
							<h4 className="card-title">Kolonlar</h4>
						</div>
						<ul>
							{this.state.content.map(content =>
								<li>
									<input type="checkbox"
										   checked={content.selected}
										   onClick={() => this.handleSelect({name: content.name, accessor: content.accessor, type: content.type, subAccessor: content.subAccessor})}
										   style={{marginRight: '10px'}}/>
									{content.name}
								</li>
							)}
						</ul>
					</div>}

					<div className={documentType === 'customer' ? 'col-sm-12' : 'col-sm-6'} style={{padding: '0'}}>
						<div className="card-header">
						</div>
						<div className='col-sm-12'>
							<input type='checkbox' checked={this.props.isAll} onClick={() => this.selectAll()}/>
							<label className='col-form-label' style={{margin: '0 0 5px 5px', fontWeight: 'bold'}}>{documentType === 'customer' ? "Tümünü Excel'e Aktar" : "Tüm Belgeleri Excel'e Aktar"}</label>
						</div>

						{documentType !== 'customer' &&
						<div className='col-sm-12 row' style={{padding: '0', margin: '10px 0 0 0'}}>
							{documentType.includes('progressPayment') &&
							<div className='col-sm-12 row' style={{padding: '0px', margin: '0 0 15px 15px'}}>
								<div className='col-sm-4'>
									<label className='col-form-label'>Bayi Seçiniz</label>
								</div>
								<div className='col-sm-7' style={{padding: '0 0 0 0', margin: '0 0 0 15px'}}>
									<Select
										clearable={false}
										className="select-control"
										value={this.props.parentCustomerId ? this.props.parentCustomerId : null}
										placeholder="Tümü"
										onChange={(e) => this.props.onChangeSelect(e,"parentCustomerId")}
										options={ Array.isArray(this.props.distributors) ? this.props.distributors : []}
									/>
								</div>
							</div>
							}

							<div className='col-sm-12' style={{padding: '0 0 0 20px', margin: '0 0 5px 0'}}>
								<label className='col-form-label' style={{fontWeight: 'bold'}}>Tarih Aralığına Göre Aktar: </label>
							</div>
							<div className='col-sm-12 row' style={{margin: '0px'}}>
								<div className='col-sm-6' style={{padding: '0 0 0 10px'}}>
									<label className='col-form-label'>Başlangıç</label>
									<Datetime locale="tr"
											  className="datepicker"
											  input={true}
											  inputProps={{
												  disabled: this.props.isAll,
												  id: 'tStartDate',
											  }}
											  closeOnSelect={true}
											  value={moment(this.props.startDate, "YYYY-MM-DD", true).isValid() ? moment(this.props.startDate).format("DD-MM-YYYY") : this.props.startDate}
											  dateFormat="DD-MM-YYYY"
											  ref="tStartDate"
											  timeFormat={false}
											  onChange={(e) => this.onChangeDate(e, 'startDate')}/>
								</div>
								<div className='col-sm-6' style={{padding: '0 0 0 10px'}}>
									<label className='col-form-label'>Bitiş</label>
									<Datetime locale="tr"
											  className="datepicker"
											  input={true}
											  inputProps={{
												  disabled: this.props.isAll,
												  id: 'tFinishDate',
											  }}
											  closeOnSelect={true}
											  value={moment(this.props.finishDate, "YYYY-MM-DD", true).isValid() ? moment(this.props.finishDate).format("DD-MM-YYYY") : this.props.finishDate}
											  dateFormat="DD-MM-YYYY"
											  ref="tFinishDate"
											  timeFormat={false}
											  onChange={(e) => this.onChangeDate(e, 'finishDate')}/>
								</div>
							</div>
						</div>}

						{!(documentType === 'customer' ||  documentType.includes('progressPayment')) &&
						<div style={{margin: '30px 0 30px 0'}}>
							<hr style={{borderWidth: '0.5px', margin: '15px 0 0 20px'}}/>
						</div>}
						{!documentType.includes('progressPayment') &&
						<div className='col-sm-12 row' style={{padding: '0', margin: '10px 0 0 0'}}>
							<div className='col-sm-12' style={{margin: '0 0 15px 0'}}>
								<h4 className='card-header'>Özelleştir</h4>
							</div>

							{(documentType === 'outbox' || documentType === 'inbox' || documentType === 'eArchive' ||
								documentType === 'eDespatchInbox' || documentType === 'eDespatchOutbox' || documentType === 'archiveVoucher') &&
							<div className='col-sm-12 row' style={{padding: '0px', margin: '0 0 15px 15px'}}>
								<div className='col-sm-4'>
									<label className='col-form-label'>Arşiv Durumu</label>
								</div>
								<div className='col-sm-7' style={{padding: '0 0 0 0', margin: '0 0 0 15px'}}>
									<Select
										clearable={false}
										className="select-control"
										value={this.props.isArchive}
										placeholder="Seçiniz..."
										onChange={(e) => this.props.filterResults(e, 'isArchive')}
										options={archiveStates}
									/>
								</div>
							</div>}


							<div className='col-sm-12 row' style={{padding: '0px', margin: '0 0 15px 15px'}}>
								<div className='col-sm-4' style={{padding: '0px'}}>
									<label
										className='col-form-label'>{this.defineTarget(this.props.type).targetName} VKN/TCKN</label>
								</div>
								<div className='col-sm-7' style={{padding: '0 0 0 0', margin: '0 0 0 15px'}}>
									<input className="form-control"
										   type="text"
										   disabled={documentType === 'customer' && this.props.isAll}
										   value={this.defineValue(this.props.type)}
										   onChange={(e) => this.props.filterResults(e, this.defineTarget(this.props.type).targetId)}/>
								</div>
							</div>

							<div className='col-sm-12 row' style={{padding: '0px', margin: '0 0 15px 15px'}}>
								<div className='col-sm-4'>
									<label
										className='col-form-label'>{this.defineTarget(this.props.type).targetName} Unvan</label>
								</div>
								<div className='col-sm-7' style={{padding: '0 0 0 0', margin: '0 0 0 15px'}}>
									<input className="form-control"
										   type="text"
										   disabled={documentType === 'customer' && this.props.isAll}
										   value={this.defineValue(this.props.value)}
										   onChange={(e) => this.props.filterResults(e, this.defineTarget(this.props.type).targetTitle)}/>
								</div>
							</div>

							{documentType === 'customer' &&
							<div className='col-sm-12 row' style={{padding: '0px', margin: '0 0 15px 15px'}}>
								<div className='col-sm-4'>
									<label className='col-form-label'>Ad</label>
								</div>
								<div className='col-sm-7' style={{padding: '0 0 0 0', margin: '0 0 0 15px'}}>
									<input className="form-control"
										   type="text"
										   disabled={this.props.isAll}
										   value={this.props.givenName}
										   onChange={(e) => this.props.filterResults(e, 'givenName')}/>
								</div>
							</div>}

							{documentType === 'customer' &&
							<div className='col-sm-12 row' style={{padding: '0px', margin: '0 0 15px 15px'}}>
								<div className='col-sm-4'>
									<label className='col-form-label'>Soyad</label>
								</div>
								<div className='col-sm-7' style={{padding: '0 0 0 0', margin: '0 0 0 15px'}}>
									<input className="form-control"
										   type="text"
										   disabled={this.props.isAll}
										   value={this.props.familyName}
										   onChange={(e) => this.props.filterResults(e, 'familyName')}/>
								</div>
							</div>}

							{documentType === 'customer' &&
							<div className='col-sm-12 row' style={{padding: '0px', margin: '0 0 15px 15px'}}>
								<div className='col-sm-4'>
									<label className='col-form-label'>Şehir</label>
								</div>
								<div className='col-sm-7' style={{padding: '0 0 0 0', margin: '0 0 0 15px'}}>
									<Select className="select-control"
											disabled={this.props.isAll}
											placeholder={"Seçiniz..."}
											onChange={(e) => this.onCityChange(e)}
										//options={this.getCitiesSelectData()}
											options={this.state.cities.map(city => ({value : city.cityName, label: city.cityName}))}
											value={this.state.selectedCity}

									/>

								</div>
							</div>}

							{/*documentType === 'customer' &&
							<div className='col-sm-12 row' style={{padding: '0px', margin: '0 0 15px 15px'}}>
								<div className='col-sm-4'>
									<label className='col-form-label'>İlçe</label>
								</div>
								<div className='col-sm-7' style={{padding: '0 0 0 0', margin: '0 0 0 15px'}}>
									<Select className="select-control"
											disabled={this.props.isAll}
											placeholder={"Seçiniz..."}
											onChange={this.onSubdivisionChange}
											value={this.state.selectedSubdivision}
											options={this.state.filteredSubdivisions.map(sd => ({value : sd.subdivisionName, label: sd.subdivisionName}))}


									/>

								</div>
							</div>*/}


							{documentType === 'customer' &&
							<div className='col-sm-12 row' style={{padding: '0px', margin: '0 0 15px 15px'}}>
								<div className='col-sm-4'>
									<label className='col-form-label'>Vergi Dairesi</label>
								</div>
								<div className='col-sm-7' style={{padding: '0 0 0 0', margin: '0 0 0 15px'}}>
									<Select className="select-control"
											disabled={this.props.isAll}
											placeholder={"Seçiniz..."}
											onChange={this.onTaxOfficeChange}

											value={this.state.selectedTaxOffice}
											options={this.state.filteredTaxOffices.map(to => ({
												value: to.vdName,
												label: to.vdName
											}))}

									/>

								</div>
							</div>}


							{(documentType === 'inbox' || documentType === 'outbox') &&
							<div className='col-sm-12 row' style={{padding: '0px', margin: '0 0 15px 15px'}}>
								<div className='col-sm-4'>
									<label className='col-form-label'>Cevap Durumu</label>
								</div>
								<div className='col-sm-7' style={{padding: '0 0 0 0', margin: '0 0 0 15px'}}>
									<Select
										clearable={false}
										className="select-control"
										value={this.props.responseCode}
										placeholder="Seçiniz..."
										onChange={(e) => this.props.filterResults(e, 'responseCode')}
										options={responseCodes}
									/>
								</div>
							</div>}

							{(documentType === 'inbox' || documentType === 'outbox') &&
							<div className='col-sm-12 row' style={{padding: '0px', margin: '0 0 15px 15px'}}>
								<div className='col-sm-4'>
									<label className='col-form-label'>Senaryo Türü</label>
								</div>
								<div className='col-sm-7' style={{padding: '0 0 0 0', margin: '0 0 0 15px'}}>
									<Select
										clearable={false}
										className="select-control"
										value={this.props.documentProfile}
										placeholder="Seçiniz..."
										onChange={(e) => this.props.filterResults(e, 'documentProfile')}
										options={documentProfiles}
									/>
								</div>
							</div>}

							{(documentType === 'inbox' || documentType === 'outbox' || documentType === 'inboxTransfer' ||
								documentType === 'outboxTransfer' || documentType === 'eArchive') &&
							<div className='col-sm-12 row' style={{padding: '0px', margin: '0 0 15px 15px'}}>
								<div className='col-sm-4'>
									<label className='col-form-label'>Fatura Türü</label>
								</div>
								<div className='col-sm-7' style={{padding: '0 0 0 0', margin: '0 0 0 15px'}}>
									<Select
										clearable={false}
										className="select-control"
										value={this.props.invoiceTypeCode}
										placeholder="Seçiniz..."
										onChange={(e) => this.props.filterResults(e, 'invoiceTypeCode')}
										options={invoiceTypeCodes}
									/>
								</div>
							</div>}

							{(documentType === 'eArchive' || documentType === 'archiveVoucher' || documentType === 'expenseNote') &&
							<div className='col-sm-12 row' style={{padding: '0px', margin: '0 0 15px 15px'}}>
								<div className='col-sm-4'>
									<label className='col-form-label'>İptal Durumu</label>
								</div>
								<div className='col-sm-7' style={{padding: '0 0 0 0', margin: '0 0 0 15px'}}>
									<Select
										clearable={false}
										className="select-control"
										value={this.props.cancelled}
										placeholder="Seçiniz..."
										onChange={(e) => this.props.filterResults(e, 'cancelled')}
										options={cancelled}
									/>
								</div>
							</div>}

						</div>
						}
					</div>
				</div>

				<div className='col-sm-12'>
					<button type="button" data-toggle="tooltip" data-placement="bottom"
							style={{background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)', float: 'right', margin: '20px 15px 30px 0'}}
							rel="tooltip" className="TekBtn ekle btn-icon"
							onClick={() => this.props.confirmCustomHeaders(this.state.customData)}>Onayla
					</button>
				</div>
			</div>
		);
	}
}

export default ExcelCustomizer;